import React from "react";
import {BrandSmall} from "../brand-small";
import {Space} from "antd";


export function Imprint() {

    return <div className="slides imprint" id="imprint">
        <BrandSmall/>
        <div className="text-content">

            <Space direction={"vertical"}>
                <h2>Impressum</h2>
                <p>
                    Sebastian Edelmeier<br/>
                    blazingtorch<br/>
                    Schröderweg 47<br/>
                    42477 Radevormwald<br/>
                </p>

                <h2>Kontakt</h2>
                <p>
                    Telefon: +49 152 0170 9134<br/>
                    E-Mail: support@blazingtorch.io
                </p>

                <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                </p>
                <p>Quelle: <a href="https://www.e-recht24.de" target="_blank"
                              rel="noreferrer">https://www.e-recht24.de </a></p>
            </Space>
        </div>
    </div>
}